import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts';
import { LanguageSelector } from '../components/common';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Language selector */}
      <div className="flex justify-end p-4">
        <LanguageSelector />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 pb-12">
        <div className="w-full max-w-sm flex flex-col items-center gap-6">

          {/* Logo / Brand */}
          <div className="w-full flex flex-col items-center">
            <img src="/logo.jpeg" alt="Fast Profile" className="w-32 h-32 rounded-3xl shadow-lg mb-4" />
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
              {t('result.brand')}
            </p>
          </div>

          {/* Title */}
          <div className="text-center">
            <h1 className="text-4xl font-black text-gray-900 mb-2">
              {t('home.title')}
            </h1>
            <p className="text-lg font-semibold text-scaleo-blue">
              {t('home.subtitle')}
            </p>
          </div>

          {/* Badge */}
          <div className="bg-white border border-gray-200 rounded-full px-4 py-2 shadow-sm">
            <p className="text-xs text-gray-500 font-medium text-center">
              {t('home.badge')}
            </p>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => navigate('/quiz')}
            className="w-full bg-scaleo-orange hover:bg-opacity-90 text-white font-bold py-4 px-8 rounded-2xl text-lg shadow-lg hover:shadow-xl transition-all hover:scale-[1.02]"
          >
            {t('home.cta')} →
          </button>


        </div>
      </div>
    </div>
  );
};

export default HomePage;
